import React from "react";
import { Container, Row, Col } from "react-bootstrap";

var Api_url = process.env.GATSBY_API_URL;
var url = Api_url + `/api/wm/yearwise/team/members/lists`;
console.log('API_URL=' + Api_url + ', url=' + url);

var image1 = Api_url + `/assets/website/images/coming_soon.png`;
console.log('image1=' + image1);

const PageContent = ({content}) => {
    return (
        <Container>
            <Row>
                <Col>
                    <p></p>
                    <div dangerouslySetInnerHTML={{ __html: content }}></div>
                </Col>
            </Row>
        </Container>
    );
};

export default PageContent;
